class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
            cartItems.updateQuantity(this.dataset.index, 0);
        });
    }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super();

        this.submitButton = document.querySelector('#CartDrawer-Checkout');
        this.spinner = this.submitButton.querySelector('.loading-overlay__spinner');

        this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

        this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
            .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);

        this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    getSectionsToRender() {
        return [
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items').dataset.id,
                selector: '.js-contents',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            },
            {
                id: 'cart-live-region-text',
                section: 'cart-live-region-text',
                selector: '.shopify-section'
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '.js-contents',
            }
        ];
    }

    updateQuantity(line, quantity, name) {
        this.enableLoading(line);

        // console.log("body");
        // console.log(line, quantity, name);
        // console.log(Number(line) + 1);
        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });
        // console.log(body);

        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
            .then((response) => {
                // console.log("¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡");
                // console.log(response);
                // this.ajaxUpdateCart();
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                // console.log("parsedState");
                // console.log(parsedState);
                requestComplete(parsedState);

                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector('cart-drawer');
                const cartFooter = document.getElementById('main-cart-footer');

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

                this.getSectionsToRender().forEach((section => {
                    const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    elementToReplace.innerHTML =
                        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));

                this.updateLiveRegions(line, parsedState.item_count);
                const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
                } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
                }
                this.disableLoading();
            }).catch(() => {
                this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
                const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
                errors.textContent = window.cartStrings.error;
                this.disableLoading();
            });
    }

    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
            const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

            lineItemError
                .querySelector('.cart-item__error-text')
                .innerHTML = window.cartStrings.quantityError.replace(
                '[quantity]',
                quantityElement.value
            );
        }

        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.add('cart__items--disabled');

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute('aria-hidden', false);

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.spinner.classList.remove('hidden');
    }

    disableLoading() {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.remove('cart__items--disabled');

        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.spinner.classList.add('hidden');
    }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
    customElements.define('cart-note', class CartNote extends HTMLElement {
        constructor() {
            super();

            this.addEventListener('change', debounce((event) => {
                const body = JSON.stringify({ note: event.target.value });
                fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
            }, 300))
        }
    });
};

/* Lo nuevo combo */

class CartCheckoutButton extends HTMLElement {
    constructor() {
        super();
        this.cartForm = document.getElementById('cart');

        this.addEventListener('click', (event) => {
            event.preventDefault();
            this.checkCartItems();
        });
    }

    groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    checkCartItems() {
        // console.log('¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡');
        var cart = CartJS.cart;
        var items = [];
        if(cart.items) {
            items = cart.items.filter((item) => !jQuery.isEmptyObject(item.properties));
        }
        var groupedByOption = this.groupBy(items, 'id');

        if (jQuery.isEmptyObject(groupedByOption)) {
            $('input[name="checkout"]').click();
        } else {
            $.each(groupedByOption, function (key, group) {
                var quantity = 0;
                $.each(group, function (key, item) {
                    quantity += item.quantity;
                });
                // console.log(group[0]);
                $.getJSON('/products/' + group[0].handle + '.js', {}, function (data) {
                    var stock = data.variants.filter((variant) => variant.id == group[0].id);
                    stock[0].inventory_quantity = 3;
                    // console.log(stock);
                    // console.log(group[0].title);
                    // console.log('¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡');
                    // console.log(quantity + ' / ' + stock[0].inventory_quantity);
                    if ((quantity > stock[0].inventory_quantity) && stock[0].inventory_policy != "continue") {
                        var sobra = (quantity - stock[0].inventory_quantity);
                        // console.log(group[0].variant_id + ' sobra ' + sobra);
                        CartJS.updateItemById(group[0].variant_id, stock[0].inventory_quantity);

                        // $.each(group, function (key, item) {
                        //     // console.log('');
                        //     // console.log('··········································');
                        //     // console.log('conjunto ' + item.properties.Conjunto);
                        //     // console.log('la q: ' + item.quantity);
                        //
                        //     if (sobra > 0) {
                        //         if (item.price == 0) {
                        //             // console.log('es braga');
                        //         }
                        //         var this_combo = form.find('input[name="combo-id"][value="' + item.properties.Conjunto + '"]');
                        //
                        //         sobra = item.quantity - sobra;
                        //
                        //         if (sobra > 0) {
                        //             // console.log('Resto ' + sobra);
                        //
                        //
                        //         } else {
                        //             // console.log('Elimino');
                        //
                        //             $($(this_combo).get().reverse()).each(function (index) {
                        //                 // console.log('--------' + $(this).data('id') + '--------');
                        //                 // console.log('Linea: ' + $(this).data('line') + ' - cantidá: ' + (quantity - stock[0].inventory_quantity));
                        //                 // console.log('------------------------');
                        //
                        //                 // CartJS.removeItem($(this).data('line'), {
                        //                 //     "success": function (data, textStatus, jqXHR) {
                        //                 //         form.submit();
                        //                 //     },
                        //                 //     "error": function (jqXHR, textStatus, errorThrown) {
                        //                 //         var response = $.parseJSON(jqXHR.responseText);
                        //                 //         $('#notification-message').text(response.message + ': ' + response.description);
                        //                 //         $('#notification-container').addClass('notification-visible');
                        //                 //         setTimeout(function () {
                        //                 //             $('#notification-container').removeClass('notification-visible');
                        //                 //         }, 5000);
                        //                 //         $('#cart__grid__loader').hide();
                        //                 //     }
                        //                 // });
                        //             });
                        //         }
                        //         // console.log('------------------------');
                        //         // console.log('');
                        //     }
                        // });
                        // console.log('··········································');
                        // console.log('');

                        // CartJS.updateItemById(group.id, stock[0].inventory_quantity);
                    }
                });
            });
        }
        // this.submitForm();
    }

    submitForm() {
        this.cartForm.submit();
    }
}

customElements.define('cart-checkout-button', CartCheckoutButton);

function reverseForIn(obj, f) {
    var arr = [];
    for (var key in obj) {
        // add hasOwnPropertyCheck if needed
        arr.push(key);
    }
    for (var i = arr.length - 1; i >= 0; i--) {
        f.call(obj, arr[i]);
    }
}

function requestComplete(cart) {
    var submitButton = document.querySelector('#CartDrawer-Checkout');
    var spinner = submitButton.querySelector('.loading-overlay__spinner');
    const cartItems = document.querySelector('#MainContent cart-items') || document.querySelector('#CartDrawer cart-drawer-items');
    // console.log("cartItems");
    // console.log(cartItems);
    // console.log('cartevent');
    // console.log(cart);
    var items = cart.items.map((item, index) => {
        if (!jQuery.isEmptyObject(item.properties)) {
            return {
                id: item.id,
                line: index + 1,
                combo: item.properties.Conjunto,
                quantity: item.quantity
            };
        }
    })

    // console.log('items');
    // console.log(items);
    var filtered = items.filter(function (el) {
        return el != null;
    });
// console.log('filtered');
// console.log(filtered);
    var grouppedByOption = groupBy(filtered, 'combo');

    // console.log('grouppedByOption');
    // console.log(grouppedByOption);
    reverseForIn(grouppedByOption, function (key) {
        // console.log(key, this[key].length);
        if (this[key].length != 2) {
            this[key].slice().reverse()
                .forEach(function (item) {
                    console.log('Eliminar', item.line);
                    cartItems.updateQuantity(item.line, 0);
                    CartJS.removeItem(item.line);
                });
        } else {
            if (this[key][0].quantity != this[key][1].quantity) {
                // console.log(this[key][1].line + ' Actualizo ' + this[key][0].quantity);
                var beforeCount = cart.item_count;
                var key = this[key];
                CartJS.updateItem(key[1].line, key[0].quantity, {}, {
                    "success": function (data, textStatus, jqXHR) {
                        // console.log('key', key);
                        // console.log('beforeCount', beforeCount);
                        // console.log(beforeCount == data.item_count);
                        cartItems.updateQuantity(key[1].line, key[0].quantity);

                        if (beforeCount == data.item_count) {
                            // console.log(key[0].line + ' Actualizo ' + key[1].quantity);

                            CartJS.updateItem(key[0].line, key[1].quantity, {}, {
                                "success": function (data, textStatus, jqXHR) {
                                    cartItems.updateQuantity(key[0].line, key[1].quantity);
                                    // console.log(textStatus, data);
                                },
                                "error": function (jqXHR, textStatus, errorThrown) {
                                    console.log(jqXHR, textStatus, errorThrown);
                                }
                            });
                        }

                    },
                    "error": function (jqXHR, textStatus, errorThrown) {
                        console.log(jqXHR, textStatus, errorThrown);
                    }
                });
            }
        }
    });

    // console.log('done');
    submitButton.classList.remove('loading');
    submitButton.removeAttribute('aria-disabled');
    spinner.classList.add('hidden');
    // updateShoppingQtyIcon(cart);
    // $('#cart__grid__loader').hide();
}

$(document).on('click', '.precheckout', function (e) {
    e.preventDefault();
    var submitButton = document.querySelector('#CartDrawer-Checkout');
    var spinner = submitButton.querySelector('.loading-overlay__spinner');

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    spinner.classList.remove('hidden');
    // $('#cart__grid__loader').show();

    $(document).ajaxStop(function (e) {
        // 0 === $.active
        // console.log('ahora');
        // submitButton.classList.remove('loading');
        // submitButton.removeAttribute('aria-disabled');
        // spinner.classList.add('hidden');

        $('input[name="checkout"]').click();
    });

    //'form#block-cart-form #checkoutSubmit, form#cart-form input[name="checkout"]'
    var cart = CartJS.cart;
    var items = cart.items.filter((item) => !jQuery.isEmptyObject(item.properties));
    var grouppedByOption = groupBy(items, 'id');
    // console.log(grouppedByOption);
    // console.log('---------------------------------------------');
    const cartItems = document.querySelector('#MainContent cart-items') || document.querySelector('#CartDrawer cart-drawer-items');
    // console.log("cartItems");
    // console.log(cartItems);

    if (jQuery.isEmptyObject(grouppedByOption)) {
        // submitButton.classList.remove('loading');
        // submitButton.removeAttribute('aria-disabled');
        // spinner.classList.add('hidden');

        $('input[name="checkout"]').click();
    } else {
        // CartJS.updateItemQuantitiesById({12345678: 6, 12345680: 0});
        $.each(grouppedByOption, function (key, group) {
            var quantity = 0;
            $.each(group, function (key, item) {
                quantity += item.quantity;
            });
            // console.log('g0', group[0]);
            $.getJSON('/products/' + group[0].handle + '.js', {}, function (data) {
                var stock = data.variants.filter((variant) => variant.id == group[0].id);
                // console.log(stock);
                if ((quantity > stock[0].inventory_quantity) && stock[0].inventory_policy != "continue") {
                    var sobra = (quantity - stock[0].inventory_quantity);
                    // console.log("sobra");console.log(sobra);

                    // cartItems.updateQuantity(this.dataset.index, 0);
                    // console.log('g', group[0], stock[0]);
                    CartJS.updateItemById(group[0].variant_id, stock[0].inventory_quantity);
                }
            });
        });
    }
});

function groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};
